import * as yup from "yup";

export const accountSchema = yup.object({
  name: yup.string().required("Name is required"),
  email: yup.string().email().required("Email is required"),
  phone: yup.string().required("Phone is required"),
  experience: yup.string().required("Experience is required"),
  designation: yup.string().required("Designation is required"),

});